import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgKlacht = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#FF5151"
      fillRule="evenodd"
      d="M31 6v26h-7.273l-3.484 3.485L16.757 32H9V6z"
      clipRule="evenodd"
    />
    <path
      fill="#00215B"
      d="m17.207 29.5 5.147 5.146-.708.708-4.853-4.854H10.5v-27H28v1H11.5v25z"
    />
    <path
      fill="#fff"
      d="M18.024 11h3.952L21.3 22.028H18.7zM20 28a1.93 1.93 0 0 1-1.422-.578A1.9 1.9 0 0 1 18 26.026q0-.843.59-1.433.591-.59 1.41-.59t1.41.59q.59.589.59 1.433 0 .817-.578 1.396Q20.843 28 20 28"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgKlacht);

export default ForwardRef;
